<template>
  <div>
    <div class="main">
      <div class="banner-box">
        <div class="banner">
          <a href="http://armors.io/" target="_blank"><img class="logo" src="../assets/lw.png"></a>
        </div>
      </div>
      <div class="search-box">
        <div class="search-box-innert">
          <el-row :gutter="20">
            <el-col :span="3">
              <div class="grid-content bg-purple padding-top-10">
                Verification Method:
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple padding-top-10">
                <template>
                  <el-radio v-model="radio_value" label="hash">Signature</el-radio>
                  <el-radio v-model="radio_value" label="file">File Proofreading</el-radio>
                </template>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple">
                <el-input v-show="radio_value === 'hash'" v-model="query_value" placeholder="Enter verification signature"></el-input>
                <el-button v-show="radio_value === 'file'" @click="selectFile">{{ fileMsg }}</el-button>
              </div>
            </el-col>
            <el-col :span="1">
              <div class="grid-content bg-purple">
                <el-button type="primary" @click="queryResult">Verification</el-button>
                <div class="file-display">
                  <input type="file" ref="fileSelect" id="select-file" @change="fileChange">
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="result">
        <div v-show="query_status" class="result-info">
          <div v-if="resultError" class="result-success">{{ msg }}</div>
          <div v-else class="result-error">{{ msg }}</div>
        </div>
        <div v-for="(item, key) in reportList" v-bind:key="key">
          <div class="result-content">
            <div class="result-title result-title-show">
              Project Name：{{ item.report.project_name }}
              <span @click="showInfo(item)">Details</span>
            </div>
            <div v-show="item.show">
              <table>
                <tr>
                  <th>Report Number</th>
                  <td>{{ item.report.audit_no }}</td>
                  <th>Audit Results</th>
                  <td>{{ item.report.test_result === 'passed' ? 'Technically COMPLETED' : item.report.test_result }}</td>
                </tr>
                <tr>
                  <th>Project Address</th>
                  <td colspan="3">{{ item.report.project_address }}</td>
                </tr>
                <tr>
                  <th>Code URL</th>
                  <td colspan="3">{{ item.report.code_url }}</td>
                </tr>
                <tr>
                  <th>Code's Hash</th>
                  <td>{{ item.report.commit }}</td>
                  <th>Blockchain</th>
                  <td>{{ item.report.platform }}</td>
                </tr>
              </table>
              <div class="result-title">Document details:</div>
              <table>
                <tr>
                  <td>File Name</td>
                  <td>Type</td>
                  <td>Signature</td>
                  <td>Attachment</td>
                </tr>
                <tr v-for='(file, index) in item.files' v-bind:key="index">
                  <td>{{ file.filename }}</td>
                  <td>{{ file.file_type }}</td>
                  <td>{{ file.md5 }}</td>
                  <td>
                    <el-button v-show="file.file_type == 'pdf'" @click="donwload(file.id)" size="mini" round>Download</el-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        Armors.io
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'HelloWorld',
  props: {
  },
  data: function () {
    return {
      query_value: "",
      query_status: false,
      msg: "Enter verification signature",
      fileMsg: "Select",
      radio_value: "hash",
      reportList: [],
      info: {
        project_name:"",
        project_address:"",
        code_url:"",
        commit:"",
        platform:"",
        audit_no:"",
        test_result:"",
        created_at:"",
      },
      files: [],
      uploadFile: null,
      resultError: false
    }
  },
  created() {
    let sign = this.getQueryString("sign")
    if(sign) {
      this.query_value = sign
      this.queryResult()
    }
  },
  methods: {
    selectFile: function () {
      this.$refs["fileSelect"].click();
    },
    getQueryString: function(name) {
      let reg = `(^|&)${name}=([^&]*)(&|$)`
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]); return null;
    },
    fileChange: function () {
      let file = this.$refs["fileSelect"].files[0];
      this.fileMsg = "Selected: " + file.name
    },
    donwload: function (id) {
      window.location.href = "/report/download?id=" + id + "&rand=" + Math.random()
    },
    queryResult: function () {
      this.query_status = true
      this.resultError = false
      this.reportList = [];
      if(this.radio_value === "hash") {
        if(this.query_value) {
          let formData = new FormData();
          formData.append("md5", this.query_value)
          this.axiosQuery({
            method: 'post',
            url: '/report/query',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        } else {
          this.msg = "Enter verification signature"
        }
      } else {
         let file = document.getElementById("select-file").files[0] || false;
         if(file) {
           this.msg = "Verification..."
           let formData = new FormData();
           formData.append("file", file)
           this.axiosQuery({
             method: 'post',
             url: '/report/file',
             data: formData,
             headers: {
               'Content-Type': 'multipart/form-data'
             }
           })
         } else {
           this.msg = "Select to be verified, pdf or sol."
         }
      }
    },
    axiosQuery: function (param) {
      axios(param).then(res => {
        console.log(res)
        if(res.data.code === "200") {
          this.msg = "Verification succeeded"
          this.resultError = true
          this.reportList = res.data.results
          console.log(this.reportList)
          if (res.data.results.length === 1) {
            this.showInfo(res.data.results[0])
          }
        } else {
          this.msg = "Verification failed"
        }
      }).catch(err => {
        console.log(err)
        this.msg = "Verification failed"
      });
    },
    showInfo: function (item) {
      console.log(item)
      item.show = !item.show
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner-box {
  height: 400px;
  background: #0e0c0c;
}
.banner {
  width: 1280px;
  margin: 0 auto;
  background: url("../assets/bg.png") no-repeat center center;
  background-size: 100%;
  height: 400px;
  position: relative;
}
.banner .logo {
  position: absolute;
  width: 150px;
  top: 10px;
  left: 10px;
}
.result {
  width: 900px;
  margin: 0 auto;
  margin-top: 10px;
  background: #ffffff;
  border-radius: 3px;
  font-size: 13px;
}
.search-box {
  width: 900px;
  margin: 0 auto;
  background: #ffffff;

}
.search-box-innert {
  padding: 10px;
}
.input-text {
  width: 800px;
  padding: 10px;
  border-radius: 3px;
  border-color: aliceblue;
}
.input-button {
  width: 70px;
  height: 39px;
  margin-left: 5px;
}
.result-info {
  padding: 10px;
}
.result-content table {
  width: 100%;
  border-collapse: collapse;
}
.result-content {
  padding: 10px;
  border: 1px solid #cccc;
  border-radius: 5px;
  margin-top: 10px;
  background: #eaeaea;
}
.result-content table {
  background: #ffffff;
}
.result-content table tr th {
  border: 1px solid #cccccc;
  padding: 10px;
  text-align: right;
  width: 110px;
}
.result-content table tr td {
  border: 1px solid #cccccc;
  padding: 10px;
  text-align: left;
}
.result-title {
  padding: 10px;
  color: #4b4444;
}
.padding-top-10 {
  padding-top: 10px;
}
.file-display {
  display: none;
}
.jigou {
  width: 900px;
  margin: 0 auto;
}
.jigou .title {
  padding: 10px;
  padding-left: 0;
}
.jigou table {
  width: 100%;
}
.jigou table tr td img {
  width: 120px;
  height: 50px;
  border: 1px solid #cccccc;
}
.footer {
  text-align: center;
  padding: 10px;
  background: #0e0c0c;
  color: #cccccc;
}
.result-success {
  background: green;
  color: white;
  padding: 10px;
}
.result-error {
  background: #ab1a1a;
  color: white;
  padding: 10px;
}
.result-title-show {
  position: relative;
}
.result-title-show span {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #147a99;
  cursor: pointer;
}
</style>
